<template>
  <div class="">
    <h2 class="modal-title">{{ data.userfullname }} {{ $t("buttons.reviewuser") }} </h2>
    <div v-if="data.filled==0">
      <div v-html="page" />
    <div  v-if="show">
        <h3>{{data.request.description}} {{ questionIndex+1 }}/ {{ requestquestions.length }}</h3>
      <h3>{{currentQuestion.question}}</h3>
        <star-rating v-if="currentQuestion.question_type==1" v-bind:increment="0.5" v-bind:star-size="30" v-model="rating"></star-rating>
        <b-form-group v-if="currentQuestion.question_type==2">
            <b-form-radio v-model="yesno" value="no">{{ $t("labels.no") }}</b-form-radio>
            <b-form-radio v-model="yesno" value="yes">{{ $t("labels.yes") }}</b-form-radio>
          </b-form-group>
        <textarea v-if="currentQuestion.question_type==3" style="width:100%; height:100px"  v-model="remarks"></textarea>
    </div>
  <button v-if="rating>0||yesno!=null||remarks!=null||currentQuestion.question_type==3" class="btn btn-primary" @click="close_and_save">{{ buttonText()}}</button>
</div>
<div v-else>
  Evaluatie reeds ingevuld
</div>
</div>
</template>

<script>
import axios from 'axios';
import { mapGetters} from 'vuex'

import StarRating from 'vue-star-rating'


export default {
  name: "reviewuser",
  data() {
    return {
      code:null,
      data:null,
      show:false,
      settings:null,
      rating:0,
      yesno:null,
      remarks:null,
      requestquestions:[],
      questionIndex:0
    }
  },
  async mounted() {
    this.code = this.$route.params.id
    axios.get('/api/public_settings').then( async (response) =>{
      this.settings = response.data
    })
    axios.get('/api/review_user/'+this.code)  .then( async (response) => {
      console.log(">> response.....", response)
      this.data=response.data
      this.requestquestions = JSON.parse(this.data.request.questions)
      this.show= true
    })
  },
  computed:{
    ...mapGetters([
      'user_metas',
      'user_by_id',
      'activebranches',
      'user_new',
      'branche_by_id',
      'createAny',
      'planning_by_id',
      'contract_by_id',
      'tag_by_id',
      'project_by_id',
      'username_by_id',
      'find_planning',
      'find_contract_id',
      'user_photo_by_id',
      'server_url',
      'append_data_string',
      'confirm_modal',
      'company_by_id',
      'find_last_planning_user'
    ]),
    page(){
      let ret = this.settings.reviewuser
      if(this.show) {
        ret = ret.replaceAll(/\[signer\]/gi, this.data.signerfullname)
        ret = ret.replaceAll(/\[user\]/gi, this.data.userfullname)
        ret = ret.replaceAll(/\[project\]/gi, this.data.project_name)
    } else {
      ret = "Bedankt voor uw beoordeling"

    }
      
      return ret
    },
    currentQuestion(){
      return this.data.questions.filter(q=>q.id==this.requestquestions[this.questionIndex])[0]?this.data.questions.filter(q=>q.id==this.requestquestions[this.questionIndex])[0]:[]
    },
  },
  methods: {
    buttonText(){
      if(this.questionIndex==this.requestquestions.length-1){
        return this.$i18n.t("buttons.saveandclose")
      } else {
        return this.$i18n.t("buttons.nextquestion")

      }

    },
    close_and_save(){
      let question_id = this.currentQuestion.id
      this.questionIndex++
      console.log("upupup",this.requestquestions[this.questionIndex])
        // console.log("close_and_save")
        let result = {}
        result.id = 0
        result.user_id= this.data.user_id
        result.signer_id= this.data.reviewer_id
        result.contract_id= this.data.contract_id
        result.rating= this.rating
        result.yesno= this.yesno=="yes"?1:0
        result.remarks= this.remarks
        result.question_id= question_id
        result.request_id= this.data.rewiewrequest_id
        console.log(result)
        axios.put("/api/review/" + result.id, result)
        .then(()=>{
          console.log("Äftersend", this.questionIndex, this.requestquestions.length)
          this.show = this.questionIndex!=this.requestquestions.length
          this.rating = 0
          this.yesno = null
          this.remarks = null
        })
    
    }
  },
  components:{StarRating}

};
</script>

